import * as x from '../helpers/xmlHelpers';

export class GeospatialInformation {
    constructor(doc)
    {
		this.label = null
		this.latitudeIdentifier = null
		this.longitudeIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.latitudeIdentifier = x.getStringElement(doc, "./ns:LatitudeIdentifier");
		this.longitudeIdentifier = x.getStringElement(doc, "./ns:LongitudeIdentifier");
   }
}

export class LocationIdentifier {
    constructor(doc)
    {
		this.label = null
		this.geospatialInformation = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:GEOSPATIAL_INFORMATION");
		if (node !== null)
				this.geospatialInformation = new GeospatialInformation(node);
   }
}

